import moment from "moment";

/**
 * 入力された日付が指定された日付以前であること
 */
export default {
  validate(value: string | undefined | null, { date }: { date: string }) {
    if (!value) {
      return true;
    }
    return moment(value).isSameOrBefore(date);
  },
};
